module.exports = __webpack_public_path__ + "static/img/openclaw.9347b7e8.png";